import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { RouterUtilsService, UserStore } from '@cxc/core/services';

export const unloggedGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const userStore = inject(UserStore);
  const router = inject(Router);
  const routerUtils = inject(RouterUtilsService);
  const { modules, logged } = userStore.get();

  if (!logged) {
    return true;
  }

  const route = routerUtils.getFirstModuleRoutePath(modules);
  router.navigate([route]);

  return false;
};
